<template>
  <div
    @click.stop="selectComponent(model)" 
    @contextmenu="onShowContextMenu"
    class="tab-content"
    :id="this.model.$ID"
    :class="evaluateClasses(classes)"
  >

    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled='readonly' v-on="on" text color="error" @click="onDeleteTab">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg"/>
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled="readonly" v-on="on" text color="success" @click="onAddTab">
            <font-awesome-icon :icon="['fal', 'plus']" size="lg" />
            <font-awesome-icon :icon="['fal', 'grip-vertical']" size="lg" />
          </v-btn>
        </template>
        <span>{{$t("vuetifyWidgets.dr-tabs.addColumn")}}</span>
      </v-tooltip>
    </portal>
    <draggable
      v-if="isInEditorMode"
      :class="[ 'dr-tab', {'dr-tab-selected': isSelected}, evaluateClasses(classes) ]"
      :group="{ name: 'container', put: ['toolbox', 'container'] }"
      :swapThreshold="0.95"
      :emptyInsertThreshold="20"
      :disabled="readonly"
      @add="onWidgetDraggableAdd"
      @update="onModelChanged"
      @change="onDraggableChanged"
      @start="onStartDraggable"
      :list="model.Widgets"
    >
      
      <component
        v-for="widget in model.Widgets || []"
        :key="widget.$ID"
        :is="widget.$Type"
        :readonly="readonly"
        :model="widget"
        :parentsWidgets="currentListOfParentsWidgets"
        @modelChanged="onModelChanged"
        @deleteComponent="onDeleteTabComponent"
        :dataSource="dataSource" @callDataSourceAction="$emit('callDataSourceAction', $event)"
      />
        
    </draggable>

    <template v-else-if="!isInEditorMode && isVisible">
      <component
        class="dr-tab"
        v-for="widget in model.Widgets || []"
        :key="widget.$ID"
        :is="widget.$Type"
        :readonly="readonly"
        :model="widget"
        @modelChanged="onModelChanged"
        @deleteComponent="onDeleteTabComponent"
        :dataSource="dataSource" @callDataSourceAction="$emit('callDataSourceAction', $event)"
      />
    </template>
    <widgets-context-menu 
      v-if="isInEditorMode"
      v-model="showContextMenu" 
      :x="x" 
      :y="y"
      :snippetCreatable="false"
      :widgetModel="model"
      @deleteComponent="onDeleteComponentFromContextMenu"
      @pasteCopiedWidget="onPasteCopiedWidget"
    />
  </div>
    
</template>

<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'
import jsonPatchMixin from '../../mixins/jsonPatchMixin'

export default {
  name: 'dr-tab',
  mixins: [mixin, contextMenuMixin, inputMixin, widgetsWrapperMixin, jsonPatchMixin],
  methods: {
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    },
    onDeleteTabComponent(val) {
      this.model.Widgets = this.model.Widgets.filter((comp) => comp != val)
      this.$emit('modelChanged', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    onDeleteTab() {
      this.$emit('onDeleteTab')
    },
    onAddTab() {
      this.$emit('onAddTab')
    }
  }
}
</script>

<style lang="css">
  .dr-tab-selected {
    outline: 2px solid #ffa500;
    outline-offset: -2px;
    min-height: 50px;
  }
</style>
